import { SubtypeDefinition } from "../../../../types/actionModule/actionModule";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";

export type DraggableState =
    | { type: 'idle' }
    | { type: 'preview'; container: HTMLElement }
    | { type: 'dragging' };

const subtypeKey = Symbol('subtype');
const newSubtypeKey = Symbol('newSubtype');
const emptyDropAreaKey = Symbol('emptyDropArea');

export type SubtypeDragData = {
    [subtypeKey]: true;
    subtype: SubtypeState;
    index: number;
    editorId: number;
};

export type NewSubtypeDragData = {
    [newSubtypeKey]: true;
    subtype: SubtypeDefinition;
};

export type DropAreaDropData = {
    [emptyDropAreaKey]: true;
}

export function getSubtypeDragData({
    subtype,
    index,
    itemId,
}: {
    subtype: SubtypeState;
    index: number;
    itemId: number;
}): SubtypeDragData {
    return {
        [subtypeKey]: true,
        subtype: subtype,
        index,
        editorId: itemId,
    };
}

export function isSubtypeDragData(data: Record<string | symbol, unknown>): data is SubtypeDragData {
    return data[subtypeKey] === true;
}

export function getNewSubtypeDragData({
    subtype,
}: {
    subtype: SubtypeDefinition;
}): NewSubtypeDragData {
    return {
        [newSubtypeKey]: true,
        subtype,
    };
}

export function isNewSubtypeDragData(data: Record<string | symbol, unknown>): data is NewSubtypeDragData {
    return data[newSubtypeKey] === true;
}


export function getDropAreaDropData(): DropAreaDropData {
    return {
        [emptyDropAreaKey]: true,
    }
}

export function isDropAreaDropData(data: Record< string | symbol, unknown>): data is DropAreaDropData {
    return data[emptyDropAreaKey] === true;
}